import React, { CSSProperties, ReactNode } from "react"
import styled from "styled-components"

type Props = {
  icon: ReactNode
  count?: number
  style?: CSSProperties
  onClick?: () => void
}

export const SocialButton: React.FC<Props> = ({
  style,
  icon,
  count,
  onClick,
}) => {
  return (
    <ButtonContainer style={style} onClick={onClick}>
      {icon}
      {count && <Count>{count}</Count>}
    </ButtonContainer>
  )
}

const ButtonContainer = styled.div`
  display: flex;
  height: 20px;
  align-items: center;
  padding: 0px 8px;
  border-radius: 3px;
  gap: 6px;
  cursor: pointer;
`

const Count = styled.p`
  font-size: 11px;
  font-weight: 700;
  color: white;
`
